import { motion, AnimatePresence } from "framer-motion";
import React from "react";
import { IoCloseOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import MiniCartItem from "../Cart/MiniCartItem";
import { useCart } from "../../hooks/useCart";
import FormatCurrency from "../../helpers/FormatCurrency";
import { FaOpencart } from "react-icons/fa6";
import LinkButton from "../../ui/LinkButton";
import { useConfig } from "../../context/ConfigContext";

function MiniCart({ isOpen, callback }) {
  const { data: cart } = useCart();

  const { setIsMiniCartOpen } = useConfig();

  console.log(cart);

  const orderViaWhatsapp = () => {
    const number = "+233502835422";

    const message = `
I want the following products

===============================

${cart?.items
  ?.map(
    (item) => `
Product: ${item?.product?.name}
Price: ${item?.price}
Quantity: ${item?.quantity}
Customization: ${item?.customisation_price}
Line Total: ${item?.line_total}
`,
  )
  .join("")}
================================
Grand Total: ${cart?.grand_total}
`;

    const encodeURI = encodeURIComponent(message);

    const whatsappURL = `https://wa.me/${number}?text=${encodeURI}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed w-full h-full z-[9999999] inset-0 overflow-hidden"
          >
            {/* Overlay */}
            <div
              className="bg-black/30 absolute w-full h-full top-0 left-0 z-50 cursor-pointer"
              onClick={() => {
                setIsMiniCartOpen(false);
                callback();
              }}
            />

            {/* Main */}
            <motion.div
              initial={{ x: 400 }}
              animate={{ x: 0 }}
              exit={{ x: 400 }}
              transition={{ duration: 0.2 }}
              className="w-full bg-white fixed h-full top-0 right-0 bottom-0 max-w-[400px] z-50"
            >
              <div className="relative h-full w-full flex flex-col">
                {/* Head */}
                <div className="px-5 py-4 flex items-center justify-between border-b w-full sticky top-0">
                  <h5 className="font-medium">{`Shopping Cart (${cart?.total_quantities || 0})`}</h5>
                  <button
                    className="text-gray-600"
                    onClick={() => {
                      setIsMiniCartOpen(false);
                      callback();
                    }}
                  >
                    <IoCloseOutline size={25} />
                  </button>
                </div>

                {/* Cart items */}
                <div className="w-full relative overflow-y-auto mt-5 px-5 h-full">
                  {cart?.items && cart?.items?.length > 0 ? (
                    <div className="flex flex-col gap-4">
                      {cart?.items?.map((cart, i) => (
                        <MiniCartItem key={i} data={cart} />
                      ))}
                    </div>
                  ) : (
                    <div className="w-full relative px-4 h-full flex items-center">
                      <div className="space-y-5">
                        <div className="flex justify-center text-gray-300">
                          <FaOpencart size={60} />
                        </div>
                        <p className="text-xl font-medium text-center">
                          Your cart is empty.
                        </p>
                        <p className="text-center text-gray-700">
                          You may check out all the available products and buy
                          some in the shop.
                        </p>
                        <div className="flex justify-center">
                          <LinkButton
                            onClick={() => callback()}
                            black
                            to="/shop"
                          >
                            Return to shop
                          </LinkButton>
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Footer */}
                {cart?.items?.length > 0 && (
                  <div className="sticky bottom-0 w-full bg-gray-100 p-4 py-6">
                    <div className="flex items-center justify-between">
                      <h1 className="font-medium text-lg">Subtotal</h1>
                      <h1 className="font-medium text-lg">
                        <FormatCurrency amount={cart?.grand_total} />
                      </h1>
                    </div>

                    {/* Buttons */}

                    <div className="w-full mt-6">
                      <Link
                        to="/cart"
                        onClick={() => callback()}
                        className="w-full hover:text-white inline-block text-center border-black rounded-full py-4 
                                              uppercase text-xs font-medium border bg-white hover:bg-black transition delay-75 ease-in-out"
                      >
                        View Cart
                      </Link>

                      <div className="mt-2">
                        <Link
                          to="/checkout"
                          onClick={() => callback()}
                          className="w-full inline-block text-center border-black rounded-full py-4 
                                              uppercase text-xs text-white font-medium border bg-black transition delay-75 ease-in-out"
                        >
                          Checkout
                        </Link>
                      </div>

                      <div className="mt-2 w-full">
                        <button
                          onClick={orderViaWhatsapp}
                          className="text-center py-4 w-full bg-green-800 text-white rounded-full uppercase text-sm"
                        >
                          Send Order Via Whatsapp
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

export default MiniCart;
